/* Header — scroll state and mobile drawer. */
(function () {
  function init(header) {
    if (header.dataset.headerReady === 'true') return;
    header.dataset.headerReady = 'true';

    // Blur only once something is actually passing underneath.
    if (header.classList.contains('nlnl-header--sticky')) {
      var onScroll = function () {
        header.classList.toggle('is-scrolled', window.scrollY > 8);
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    // --- Horizon compatibility -------------------------------------------
    // theme.liquid's inline script sets --header-height / --header-group-height
    // by querying <header-component>, which this header does not use, so it
    // bails early and leaves those variables unset. Several Horizon layout
    // rules depend on them. Publish them ourselves.
    function publishHeights() {
      var h = header.offsetHeight;
      document.body.style.setProperty('--header-height', h + 'px');
      document.body.style.setProperty('--header-group-height', h + 'px');
      document.body.style.setProperty('--transparent-header-offset-boolean', '0');
      var bar = header.querySelector('.nlnl-header__bar');
      if (bar) document.body.style.setProperty('--top-row-height', bar.offsetHeight + 'px');
    }
    publishHeights();
    if (window.ResizeObserver) new ResizeObserver(publishHeights).observe(header);
    window.addEventListener('resize', publishHeights, { passive: true });

    var burger = header.querySelector('[data-nlnl-burger]');
    var drawer = header.querySelector('[data-nlnl-drawer]');
    if (!burger || !drawer) return;

    function setOpen(open) {
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      drawer.classList.toggle('is-open', open);
      drawer.hidden = !open; // kept for assistive tech; CSS uses the class
    }

    burger.addEventListener('click', function () {
      setOpen(burger.getAttribute('aria-expanded') !== 'true');
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && burger.getAttribute('aria-expanded') === 'true') {
        setOpen(false);
        burger.focus();
      }
    });

    // Close when the viewport grows past the mobile breakpoint, or the
    // drawer stays open behind a nav that is now visible.
    var mq = window.matchMedia('(min-width:990px)');
    var onChange = function () { if (mq.matches) setOpen(false); };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
  }

  function boot() { document.querySelectorAll('.nlnl-header').forEach(init); }
  document.addEventListener('shopify:section:load', boot);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
